import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=b93e6a7a&scoped=true&"
import script from "./leave.vue?vue&type=script&lang=js&"
export * from "./leave.vue?vue&type=script&lang=js&"
import style0 from "./leave.vue?vue&type=style&index=0&id=b93e6a7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93e6a7a",
  null
  
)

export default component.exports